// extracted by mini-css-extract-plugin
module.exports = {"ListNews":"styles_ListNews__JvkSN","CardsList":"styles_CardsList__7EdCI"};